import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { FLEX_ROW } from '../flexBox';
import { COLORS } from '../../globalStyle/colors';
import { css } from '@emotion/core';
import { Z_INDEX } from '../../globalStyle/zIndex';
import { SHOW_ON_MOBILE } from '../../globalStyle/mediaQueries';
import LocalDiv from '../../localization/LocalDiv';


const styles = {
  root: [
    SHOW_ON_MOBILE,
    FLEX_ROW,
    css`
      justify-content: flex-end;
      width: 100vw;
      height: 72px;
      position: fixed;
      bottom: 0;
      z-index: ${Z_INDEX.MOBILE_TOOLBAR};
      background-color: ${COLORS.WHITE};
    `,
  ],
};


type Props = {
  className?: string;
};


/**
 * MobileToolbar: a component that renders the little toolbar of buttons that often appears at the bottom of pages in
 * the mobile version of the site. The toolbar floats on top of the page content
 *
 * PureComponent: true
 * Redux Connected: false
 */
const MobileToolbar: React.FC<Props> = props => ReactDOM.createPortal(
  <LocalDiv className={props.className} css={[FLEX_ROW, styles.root]}>
    {props.children}
  </LocalDiv>,
  document.getElementById('root') || document.getElementById('react-root') || document.body,
);

export default MobileToolbar;
